import { render, staticRenderFns } from "./AgentMonthlyBillInfo.vue?vue&type=template&id=56b31b44&"
import script from "./AgentMonthlyBillInfo.vue?vue&type=script&lang=js&"
export * from "./AgentMonthlyBillInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports